/**
 * Farm & Acre Co - Button Pairing System
 *
 * Handles the MANDATORY "Do you need matching buttons?" Yes/No choice for female tag products:
 * - Records the choice on the order line as the visible "Matching Buttons: Yes/No" property
 * - On "Yes": reveals the qty/subtotal block and syncs button quantity to tag quantity
 * - Cart addition of the button product on "Yes" is handled by fee-auto-add.js (single API call)
 * - The Yes/No selection itself is validated by form-validation.js (data-allflex-field="button-pairing")
 */

(function () {
  'use strict';

  var pairingEl;
  var yesRadio;
  var noRadio;
  var detailsEl;
  var qtyDisplay;
  var subtotalDisplay;
  var hiddenInput;
  var buttonProductId;
  var buttonProductTitle;
  var buttonProductHandle;
  var buttonPrice;

  function init() {
    pairingEl = document.getElementById('AllflexButtonPairing');
    if (!pairingEl) return;

    yesRadio = document.getElementById('matching-buttons-yes');
    noRadio = document.getElementById('matching-buttons-no');
    detailsEl = document.getElementById('button-pairing-details');
    qtyDisplay = document.getElementById('button-pairing-qty');
    subtotalDisplay = document.getElementById('button-pairing-subtotal');
    hiddenInput = document.getElementById('button-pairing-hidden');

    buttonProductId = pairingEl.dataset.buttonProductId;
    buttonProductTitle = pairingEl.dataset.buttonProductTitle;
    buttonProductHandle = pairingEl.dataset.buttonProductHandle;
    // Shopify Liquid outputs variant.price in cents, convert to dollars
    buttonPrice = (parseFloat(pairingEl.dataset.buttonPrice) || 0) / 100;

    if (!yesRadio || !noRadio) return;

    yesRadio.addEventListener('change', onChoiceChange);
    noRadio.addEventListener('change', onChoiceChange);
    // Sync state on load (covers back-button restores where a radio is pre-checked)
    onChoiceChange();

    // Listen for quantity changes (keeps the synced button subtotal live)
    document.addEventListener('change', function (e) {
      if (e.target.closest('quantity-input') && e.target.classList.contains('quantity__input')) {
        updateButtonQuantityDisplay();
      }
    });

    document.addEventListener('input', function (e) {
      if (e.target.closest('quantity-input') && e.target.classList.contains('quantity__input')) {
        updateButtonQuantityDisplay();
      }
    });
  }

  function isYesSelected() {
    return !!(yesRadio && yesRadio.checked);
  }

  function onChoiceChange() {
    var isYes = isYesSelected();

    if (detailsEl) {
      detailsEl.style.display = isYes ? '' : 'none';
    }

    // Record the choice on the order line only once a radio is actually picked.
    if (hiddenInput) {
      if (isYes) {
        hiddenInput.value = 'Yes';
      } else if (noRadio && noRadio.checked) {
        hiddenInput.value = 'No';
      } else {
        hiddenInput.value = '';
      }
    }

    if (isYes) {
      updateButtonQuantityDisplay();
    }
  }

  function getTagQuantity() {
    var qtyInput = document.querySelector('.quantity__input[form]') ||
                   document.querySelector('quantity-input .quantity__input');
    if (qtyInput) {
      return Math.max(1, parseInt(qtyInput.value) || 1);
    }
    return 1;
  }

  function updateButtonQuantityDisplay() {
    if (!isYesSelected()) return;

    var qty = getTagQuantity();
    var subtotal = qty * buttonPrice;

    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (subtotalDisplay) subtotalDisplay.textContent = '$' + subtotal.toFixed(2);
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
